import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { serviceProvider } from "../../../../comun/provider/ServiceProvider";
import { TareaEjecucionAsignarTareaRequest } from "../../../../modulos/rastro/request/TareaEjecucionAsignarTareaRequest";
import { TareaEjecucionResponse } from "../../../../modulos/rastro/response/TareaEjecucionResponse";
import { fx_createTareaEjecucionAsignarTareaGrpcService } from "../../../../modulos/rastro/services/TareaEjecucionAsignarTareaGrpcService";
import { BaseFullScreenFormModalRender } from "../../../base/modal/BaseFullScreenFormModalRender";
import { IFormBodyRender } from "../../../definitions/form/IFormBodyRender";
import { TareasSinAsignarFormRender } from "../form/TareasSinAsignarFormRender";

/** Modal a pantalla completa que lista las ejecuciones de tarea de la finca
 *  sin clasificar (`tareaId` null) y exige asignarles tarea a todas. Guarda
 *  con `fx_createTareaEjecucionAsignarTareaGrpcService`, que envía
 *  `request.asignaciones` tal cual (una entrada por fila). */
export class TareasSinAsignarModalRender extends BaseFullScreenFormModalRender<
  TareaEjecucionAsignarTareaRequest,
  TareaEjecucionAsignarTareaRequest
> {
  protected readonly elementId = "tareasSinAsignarModal";

  /**
   * @param _ejecuciones Ejecuciones sin clasificar de la finca activa.
   * @param _fincaId     Finca activa (scope del servicio de guardado).
   * @param _clienteId   Cliente dueño de la finca (catálogo de tareas).
   */
  constructor(
    private readonly _ejecuciones: TareaEjecucionResponse[],
    private readonly _fincaId: string,
    private readonly _clienteId: string,
  ) {
    super({ asignaciones: [] });
  }

  protected get title(): string {
    return "Tareas sin asignar";
  }

  protected get subtitle(): string | undefined {
    return serviceProvider.getFincaSelectedService().get()?.nombreFinca;
  }

  protected get saveLabel(): string {
    return "Guardar";
  }

  protected getFormBody(): IFormBodyRender {
    return new TareasSinAsignarFormRender(
      this._request,
      this._ejecuciones,
      this._clienteId,
    );
  }

  protected get saveService(): ISaveService<
    TareaEjecucionAsignarTareaRequest,
    TareaEjecucionAsignarTareaRequest
  > {
    return fx_createTareaEjecucionAsignarTareaGrpcService(this._fincaId);
  }
}
